import { takeLatest } from 'redux-saga/effects';
import { ULTRASOUND_FETCH_ALL } from './constants';
import { fetchUltrasoundScans } from './sagas';

function *ultrasoundSagas () {
  yield takeLatest(ULTRASOUND_FETCH_ALL, fetchUltrasoundScans);
}

export default ultrasoundSagas;
